export default {
  props: ['title', 'info'],
  mounted() {
    document.onkeydown = evt => {
      evt = evt || window.event;

      const modalContainer = document.getElementById('modals-container');

      if (evt.keyCode === 27 && modalContainer && modalContainer.children.length === 0) {
        const btnCloseCheckout = document.getElementById('btnCloseCheckout');

        if (btnCloseCheckout) {
          document.getElementById('btnCloseCheckout').click();
        }
      }
    }
  },
};
